/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener("DOMContentLoaded", function() {



  var ProductForm__StickyButtonEl = document.querySelector('.ProductForm__StickyButton');
  if(ProductForm__StickyButtonEl) {
    function isElementInViewport (el) {
      if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
      }

      var rect = el.getBoundingClientRect();

      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
      );
    }
    function checkStickyButtonPosition(el) {
      var window_width = window.innerWidth;
      if(window_width <= 640) {

        var ProductForm__BuyButtonsEl = document.querySelector('.ProductForm__BuyButtons');
        if(ProductForm__BuyButtonsEl) {
          console.log(isElementInViewport(ProductForm__BuyButtonsEl));
          if(isElementInViewport(ProductForm__BuyButtonsEl)) {
            el.classList.add('hide_button');
          } else {
            el.classList.remove('hide_button');
          }
        }
      }
    };
    checkStickyButtonPosition(ProductForm__StickyButtonEl);
    document.addEventListener('scroll', function(e) {
      checkStickyButtonPosition(ProductForm__StickyButtonEl);
    });


    document.addEventListener('click', function(e){
      var el = e.target;

      if(el.classList.contains('ProductForm__StickyButton') || el.closest('.ProductForm__StickyButton')) {
        if(!el.classList.contains('ProductForm__StickyButton')) {
          el = el.closest('.ProductForm__StickyButton');
        }

        e.preventDefault();
        
        var isSingleProduct = el.getAttribute('data-single-product');
        if(isSingleProduct == 'true') {
          var main_ATC_El = document.querySelector('.ProductForm__BuyButtons .ProductForm__AddToCart');
          if(main_ATC_El) {
            main_ATC_El.dispatchEvent(new Event('click', { bubbles: true }));
          }
        } else {
          var ProductForm__VariantsEl = document.querySelector('.ProductForm__Variants');
          if(ProductForm__VariantsEl) {
            var elem_offsetTop = ProductForm__VariantsEl.offsetTop;
            window.scrollTo({
              top: elem_offsetTop,
              behavior: "smooth"
            });
          }
        }
      }
    });
  }
});